import { useContext } from 'react';

import CompareModalContext from './compareModal.context';

function useCompareModal() {
  const context = useContext(CompareModalContext);

  if (!context) {
    throw new Error('useCompareModal must be used within CompareModalContext');
  }

  return context;
}

export default useCompareModal;